import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { Constants } from '../../common';
import { MatDialog } from '@angular/material/dialog';
import { Auth } from './auth';
import { SessionExpiredDialogComponent } from '../../shared';

let isDialogOpen = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(Auth);
  const dialog = inject(MatDialog);

  const token = localStorage.getItem(Constants.TOKEN_KEY);

  // 🔥 APIs to exclude from 401 handling
  const excludedEndpoints = [
    'super-admin-login/',
    'super-admin-clear-token/',
    'super-admin-generate-jwt-token/'
  ];

  const isExcluded = excludedEndpoints.some(endpoint =>
    req.url.includes(endpoint)
  );

  // Attach token
  const modifiedReq = token
    ? req.clone({
      headers: req.headers.set('Authorization', 'Token ' + token),
    })
    : req;

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {

      // 🔴 HANDLE 401 (only if NOT excluded)
      if (
        error.status === 401 &&
        !isExcluded &&
        !isDialogOpen
      ) {

        isDialogOpen = true;

        const dialogRef = dialog.open(SessionExpiredDialogComponent, {
          width: '400px',
          disableClose: true,
          data: {
            title: 'Session Expired',
            message: 'Your session has expired. Please login again.'
          }
        });

        dialogRef.afterClosed().subscribe(() => {
          isDialogOpen = false;
          authService.logout();
        });
      }

      return throwError(() => error);
    })
  );
};